var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoneSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00073 6.80001L1.6674 4.46667C1.4074 4.20667 0.994062 4.20667 0.734062 4.46667C0.474063 4.72667 0.474063 5.14001 0.734062 5.40001L3.5274 8.19334C3.7874 8.45334 4.2074 8.45334 4.4674 8.19334L11.5341 1.13334C11.7941 0.873338 11.7941 0.460005 11.5341 0.200005C11.2741 -0.0599951 10.8607 -0.0599951 10.6007 0.200005L4.00073 6.80001Z",
    fill: "#50BD89"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoneSm);
export default __webpack_public_path__ + "static/media/doneSm.2ecffb92.svg";
export { ForwardRef as ReactComponent };